<template>
  <div class="p-4">
    <button @click="$modal.show('attach-customer')" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded mb-6">
      Attach Item
    </button>
    <el-table
      :data="customers"
      :empty-text="'No Level Items available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        label="Customer">
      </el-table-column>
      <el-table-column
        label="Membership No">
      </el-table-column>
      <el-table-column
        label="Loyalty Level">
      </el-table-column>
      <el-table-column
        prop="point"
        label="Point">
      </el-table-column>
      <el-table-column
        prop="reward_balance"
        label="Reward Balance">
      </el-table-column>
      <el-table-column
        align="center"
        label="Operations">
        <template slot-scope="scope">
          <el-button type="text" size="small">
            <i title="Delete Level Item" class="text-sm text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-8 mb-8 float-right"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
    <AttachCustomersToLevel />
  </div>
</template>

<script>
import AttachCustomersToLevel from './_includes/AttachCustomersToLevel.vue';

export default {
  name: 'LevelCustomers',
  components: {
    AttachCustomersToLevel,
  },
  data() {
    return {
      loading: false,
      page: 1,
      limit: 20,
    };
  },
  computed: {
    customers() {
      return this.$store.state.LoyaltyModule.customers.customers;
    },
    pagination() {
      return this.$store.state.LoyaltyModule.customers.pagination;
    },
  },
  methods: {
    async handleSizeChange(args) {
      this.limit = args;
      await this.fetchLoyaltyCustomers();
    },
    async handleCurrentChange(args) {
      this.page = args;
      await this.fetchLoyaltyCustomers();
    },
    async fetchLoyaltyCustomers() {
      if (!this.$route.params.id) {
        await this.$store.dispatch('LoyaltyModule/fetchAllLoyaltyCustomers', {
          page: this.page,
          limit: this.limit,
        });
      } else {
        await this.$store.dispatch('LoyaltyModule/fetchCustomersByLoyalty', {
          loyaltyId: this.$route.params.id,
          page: this.page,
          limit: this.limit,
        });
      }
    },
  },
  async mounted() {
    await this.fetchLoyaltyCustomers();
  },
};
</script>

<style scoped>

</style>
